"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersLayout = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _InputWithIcon = require("../../elements/input-with-icon/InputWithIcon");
var _react = _interopRequireDefault(require("react"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _filtersLayoutModule = _interopRequireDefault(require("./filters-layout.module.scss"));
var _useDebouncedSearch3 = require("./useDebouncedSearch");
var FiltersLayout = function FiltersLayout(_ref) {
  var querySearch = _ref.querySearch,
    setQuerySearch = _ref.setQuerySearch,
    additionalSelect = _ref.additionalSelect,
    children = _ref.children;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var _useDebouncedSearch = (0, _useDebouncedSearch3.useDebouncedSearch)(querySearch, setQuerySearch),
    _useDebouncedSearch2 = (0, _slicedToArray2.default)(_useDebouncedSearch, 2),
    search = _useDebouncedSearch2[0],
    onSearchChange = _useDebouncedSearch2[1];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _filtersLayoutModule.default['filters-layout']
  }, additionalSelect, /*#__PURE__*/_react.default.createElement(_InputWithIcon.SearchInput, {
    containerClassName: (0, _classnames.default)(_filtersLayoutModule.default['filters-layout__search']),
    id: "search",
    name: "search",
    onChange: onSearchChange,
    value: search,
    placeholder: t('filtersLayout.search')
  }), children);
};
exports.FiltersLayout = FiltersLayout;